
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Message from "@/components/message.vue"
	import{
		getSearchDate,
		nextDay
	} from "@/utils/index"
	import PickerDate from '@/components/picker-date.vue';
  import {
    productSettlementlist
  } from '@/api/order'
	import {
		UserModule
	} from "@/store/modules/user"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private filterTime = getSearchDate(2,false,-1)
    private keywords = ''
    private suppliers = null
    private supplierslist:any = []
    private tablelist:any = []
    private totallist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0

    private exShow = false
    // get userId(){
    //   return Number(UserModule.mallInfo.EmployeeId)
    // }
    private mounted () {
      this.gettablelist()
    }

    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          // ProviderId:this.suppliers,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if (this.filterTime&&this.filterTime.length) {
          var dt = this.filterTime
          data.StartTime = dt[0];
          data.EndTime = nextDay(dt[1],1)
        }
        let res = await productSettlementlist(data)
        if(res.IsSuccess){
          this.totallist = [res.Result.TotalStatistic]
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.pageNo = 1
      this.keywords = ''
      this.filterTime = getSearchDate(2,false,-1)
      this.suppliers = null
      this.gettablelist()
    }
    private exportExcel(){
      let url = location.origin + '/provider/order/productSettlement/list'
      url += '?Keywords=' + this.keywords
      url += '&ProviderId=' + (this.suppliers||'')
      if (this.filterTime&&this.filterTime.length) {
        var dt = this.filterTime
        url += '&StartTime=' + (dt[0]||'')
        url += '&EndTime=' + (nextDay(dt[1],1)||'')
      }
      window.open(url)
    }
  }
